import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TagComponent } from "src/app/components/ui/tag/tag.component";

@NgModule({
  imports: [CommonModule],
  declarations: [TagComponent],
  exports: [TagComponent]
})
export class TagModule {}
